import BrandPages from "dashboard/pages/brand";

const Pages = {};

Pages.BrandPages = BrandPages

export default Pages;
